module.exports = "<div class=\"content form-rich-editor\"> <div class=toolbar></div> <div class=editor></div> </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/quill-alert/quill-alert.html
// module id = 2102
// module chunks = 50